import React from "react";
import { Container, ProgressBar } from "react-bootstrap";
import Card from "../HOME/Card";
import { Rate } from "antd";
import Slider from "react-slick";
import FAQ from "../HOME/FAQ";
import RecentSearch from "../HOME/RecentSearch";

const LaptopDesc = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
   
      <section className="py-4">
        <Container>
          <div style={{backgroundColor:"#F4F4F4"}} className="p-3">
            <h2 className="head-txt-1 text-start">
              <span>Detailed</span> Overview
            </h2>
            <p className="pt-3" style={{ textIndent: "2rem", fontWeight: 500 }}>
              The Samsung Galaxy A15 5G boasts a sleek and modern design,
              featuring a durable plastic frame and back. The device has a
              comfortable in-hand feel with rounded edges and a matte finish
              that resists fingerprints. It’s available in several color
              options, including black, white, and blue, giving users some
              flexibility in style.
            </p>
            <table className="decs-table">
              <tr>
                <th>Display</th>
                <td style={{backgroundColor:"#FFFFFF",border:"1px solid #EBEBEB"}}>6.5-inch Infinity-V display with a Full HD+ resolution</td>
              </tr>
              <tr>
                <th>Performance</th>
                <td style={{backgroundColor:"#FFFFFF",border:"1px solid #EBEBEB"}}>MediaTek Dimensity 700 chipset</td>
              </tr>
              <tr>
                <th>Camera System</th>
                <td style={{backgroundColor:"#FFFFFF",border:"1px solid #EBEBEB"}}><span>Main Camera: 50MP</span><span className="mx-3">Ultra-Wide Camera: 5MP </span><span>Depth Sensor: 2MP</span></td>
              </tr>
              <tr>
                <th>Battery Life</th>
                <td style={{backgroundColor:"#FFFFFF",border:"1px solid #EBEBEB"}}>5,000mAh battery,</td>
              </tr>
              <tr>
                <th>Connectivity and 5G</th>
                <td style={{backgroundColor:"#FFFFFF",border:"1px solid #EBEBEB"}}>Wi-Fi 802.11ac, Bluetooth 5.1, NFC, and a USB Type-C port</td>
              </tr>
              <tr>
                <th>Software and Features</th>
                <td style={{backgroundColor:"#FFFFFF",border:"1px solid #EBEBEB"}}>UI 5.0 based on Android 13</td>
              </tr>
            </table>
          </div>
        </Container>
      </section>
      <div style={{ overflowX: "hidden" }}>
        <section className="py-4">
          <Container>
            <h2 className="head-txt-1 text-start">
              <span>Smart</span> Prize Compare
            </h2>
            <div className="row">
              <div className="sm-hidevs col-lg-3 col-md-4">
                <div className="col-lg-3 col-md-4 col-sm-4 col-4 d-flex justify-content-center align-items-center">
                  <div>
                    <img className="img-fluid vs" src="/assets/vs.png" />
                  </div>
                </div>
              </div>
              {/* <Card /> */}
            </div>
            <div className="pt-3">
              <table className="table-view">
                <tr>
                  <th>Prize</th>
                  <th>₹ 19,499.00</th>
                  <th>₹ 19,499.00</th>
                  <th>₹ 19,499.00</th>
                </tr>
                <tr>
                  <td>Rating</td>
                  <td>
                    <Rate disabled defaultValue={2} className="rate-table" />
                  </td>
                  <td>
                    <Rate disabled defaultValue={2} className="rate-table" />
                  </td>
                  <td>
                    <Rate disabled defaultValue={2} className="rate-table" />
                  </td>
                </tr>
                <tr>
                  <td>Screen size</td>
                  <td>16.39 cm</td>
                  <td>16.39 cm</td>
                  <td>16.39 cm</td>
                </tr>
                <tr>
                  <td>Hard Disk</td>
                  <td>128 GB</td>
                  <td>128 GB</td>
                  <td>128 GB</td>
                </tr>
                <tr>
                  <td>Computer memory size </td>
                  <td>8G</td>
                  <td>8G</td>
                  <td>8G</td>
                </tr>
                <tr>
                  <td>CPU manufacturer </td>
                  <td>Intel </td>
                  <td>Intel </td>
                  <td>Intel </td>
                </tr>
                <tr>
                  <td>CPU speed</td>
                  <td>1.7 GHz</td>
                  <td>1.7 GHz</td>
                  <td>1.7 GHz</td>
                </tr>
                <tr>
                  <td>CPU model number </td>
                  <td>Core i5 Family</td>
                  <td>Core i5 Family</td>
                  <td>Core i5 Family</td>
                </tr>
                <tr>
                  <td>Operating system </td>
                  <td>Windows 10</td>
                  <td>Windows 10</td>
                  <td>Windows 10</td>
                </tr>
                <tr>
                  <td>Ram Tech</td>
                  <td>DDR4</td>
                  <td>DDR4</td>
                  <td>DDR4</td>
                </tr>
                <tr>
                  <td>Graphic Co-processor </td>
                  <td>Intel UHD Graphics 620</td>
                  <td>Intel UHD Graphics 620</td>
                  <td>Intel UHD Graphics 620</td>
                </tr>
                <tr>
                  <td>GPU manufacturer </td>
                  <td>Intel</td>
                  <td>Intel </td>
                  <td>Intel </td>
                </tr>
                <tr>
                  <td>Wireless Tech</td>
                  <td>Wi-Fi</td>
                  <td>Wi-Fi</td>
                  <td>Wi-Fi</td>
                </tr>
              </table>
            </div>
          </Container>
        </section>
        <section>
          <Container>
            <div>
              <h2 className="head-txt-1 text-start">
                <span>Customer</span> Review
              </h2>
              <div className="row">
                <div className="col-lg-7">
                  <div>
                    <table className="table-reivew">
                      <tr>
                        <td>5 Star</td>
                        <td>
                          <ProgressBar now={60} />
                        </td>
                      </tr>
                      <tr>
                        <td>4 Star</td>
                        <td>
                          <ProgressBar now={60} />
                        </td>
                      </tr>
                      <tr>
                        <td>3 Star</td>
                        <td>
                          <ProgressBar now={60} />
                        </td>
                      </tr>
                      <tr>
                        <td>2 Star</td>
                        <td>
                          <ProgressBar now={60} />
                        </td>
                      </tr>
                      <tr>
                        <td>1 Star</td>
                        <td>
                          <ProgressBar now={60} />
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div className="col-lg-5 d-flex justify-content-start align-items-center">
                  <div>
                    <div>
                      <Rate disabled defaultValue={2} className="rating-star" />
                      4.0
                      <p className="revieew">1550 Rating & 300 Reviews </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
        <section className="py-4">
          <Container>
            <h2 className="head-txt-1 text-start">
              <span>Top</span> Reviews
            </h2>
            <div className="row">
              <div className="slider-container">
                <Slider {...settings}>
                  <div className="px-3">
                    <div className="review-slide">
                      <p>John k</p>
                      <Rate
                        disabled
                        defaultValue={2}
                        style={{ fontSize: "12px" }}
                      />
                      <p>
                        The camera quality is phenomenal, especially in low
                        light, and the performance is lightning-fast.
                      </p>
                    </div>
                  </div>
                  <div className="px-3">
                    <div className="review-slide">
                      <p>John k</p>
                      <Rate
                        disabled
                        defaultValue={2}
                        style={{ fontSize: "12px" }}
                      />
                      <p>
                        The camera quality is phenomenal, especially in low
                        light, and the performance is lightning-fast.
                      </p>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </Container>
        </section>
      </div>
      <FAQ />
      <RecentSearch />
    </>
  );
};

export default LaptopDesc;
